import { Endpoints, FetchManager, DropzoneHandler } from 'js-pimcore-formbuilder';
import AirDatepicker from 'air-datepicker';
import IMask from 'imask';
import localeDe from 'air-datepicker/locale/de';
import ClassWatcher from  '../../../assets/src/js/classWatcher'
import { isEditMode } from '../../../assets/src/js/utils';

window.dataLayer = window.dataLayer || [];

function validateForm(event, form, errorMessage) {
    
    sendFormDataLayer('formSubmit', form);
    
    if ([...form.querySelectorAll('.dz-error')].length > 0 || !validateFileUploadFields(form)) {
        alert(errorMessage);
        
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return false;
    }
}

function validateFileUploadFields(form){
    const requiredFileUploads = form.querySelectorAll('.dynamic-multi-file.element-adapter[data-required="1"]');
    
    if(requiredFileUploads){
        for (let i = 0; i < requiredFileUploads.length; i++) {
            const element = requiredFileUploads[i];
            if(element.querySelectorAll('.dz-preview.dz-success.dz-complete').length === 0){
                toggleFileUploadError(element, true)
                return false;
            }
            
            toggleFileUploadError(element, false)
        }
    }

    return true;
}

function toggleFileUploadError(element, active){
    element.classList.toggle('error-field', active);
}

function sendFormDataLayer(event, form) {
    if (window.dataLayer) {
        window.dataLayer.push({
            event,
            formName: form.closest('.FormPage')?.getAttribute('data-form-title') ?? form.getAttribute('action'),
        });
    }
}

export default class Index {
    constructor(rootNode, props) {
        if (isEditMode()) {
            return;
        }

        this.props = props;

        this.$refs = {
            rootNode,
            forms: rootNode.querySelectorAll('form.formbuilder.ajax-form'),
            success: rootNode.querySelector('form.formbuilder.ajax-form .success-notice'),
            fail: rootNode.querySelector('form.formbuilder.ajax-form .error-notice')
        };
        if (this.$refs.forms.length) {
            this.$refs.forms.forEach((form) => {
                form.addEventListener('submit', (event) => validateForm(event, form, this.props.dropzoneErrorMessage), true);

                this.initDatepicker(form)
            });

            new Endpoints().getEndpoints(this.$refs.forms[0].dataset.ajaxStructureUrl)
            .then((endpoints) => {
                this.$refs.forms.forEach((form) => {
                    new DropzoneHandler(form, {}, endpoints);

                    const dropzoneContainer = form.querySelector('.dropzone-container');

                    if(dropzoneContainer) {
                        const dropzoneLabel = dropzoneContainer.closest('.form-row').querySelector('.theme-label');

                        if (dropzoneLabel) {
                            new ClassWatcher(dropzoneContainer, 'dz-started', () => {
                                dropzoneLabel.classList.add('has-value');
                            }, () => {
                                dropzoneLabel.classList.remove('has-value');
                            });
                        }
                    }

                    new FetchManager(form, {
                        elementTransformer: {
                            addValidationMessage: (form, field, messages) => {
                                field.classList.add('error-field');
                                messages.forEach((message) => {
                                    let errorEl = document.createElement('div');
                                    errorEl.className = 'error-message error-notice bg-red text-white p-4 my-6';
                                    errorEl.innerText = message;
                                    field.after(errorEl);
                                });
                            },
                            removeFormValidations: (form) => {
                                form.querySelectorAll('.error-field').forEach((el) => el.classList.remove('error-field'))
                                form.querySelectorAll('.error-message').forEach((el) => el.remove());
                                if (rootNode.querySelector('form.formbuilder.ajax-form .file-notice')) {
                                    rootNode.querySelector('form.formbuilder.ajax-form .file-notice').style.display = 'none';
                                }
                            },
                        },
                        onSuccess: (responses, redirect) => {
                            this.reset()

                            sendFormDataLayer('formSubmitSuccess', form);

                            responses.forEach((response) => {
                                let success = document.createElement('div');
                                success.className = 'success-notice bg-green text-white p-4 my-6';
                                success.innerHTML = response.message;
                                form.prepend(success);

                                if (redirect) {
                                    window.location.replace(redirect);
                                } else if(form) {
                                    this.scrollTo(success);
                                }
                            });
                        },
                        onFail: () => {
                            this.reset()

                            sendFormDataLayer('formSubmitError', form);

                            if (rootNode.querySelectorAll('.formbuilder .dz-error').length) {
                                rootNode.querySelector('form.formbuilder.ajax-form .file-notice').style.display = 'block';

                                let elements = form.querySelectorAll('.dz-remove');
                                elements.forEach((el) => el.style.display = 'block');
                            }
                            this.$refs.fail.style.display = 'block';
                            this.scrollTo(this.$refs.fail);
                        },
                    }, endpoints);
                });
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    scrollTo(el){
        const nav = document.querySelector('.NavigationComponent');
        const navHeight = nav.getBoundingClientRect().height;

        const y = el.getBoundingClientRect().top + window.pageYOffset - navHeight - 20;

        window.scrollTo({top: y, behavior: 'smooth'})
    }

    reset() {
        this.$refs.forms.forEach((form) => {
            form.querySelectorAll('.success-notice').forEach((el) => el.remove());
            this.$refs.fail.style.display = 'none';
        });
    }

    initDatepicker(form) {
        const datePicker = form.querySelector("input.datepicker-date");
        const timePicker = form.querySelector(".time-group input");

        if(!datePicker || !timePicker) return;

        new AirDatepicker(datePicker, {
            locale: localeDe,
            startDate: new Date(),
            minDate: new Date(),
            altField: form.querySelector("[name*='[date]']"),
            altFieldDateFormat: 'yyyy-MM-dd',
            onSelect: (date) => {
                if(date) {
                    timePicker.focus();
                    timePicker.setAttribute('required', 'required');
                    if(timePicker.value === '') {
                        timePicker.value = '12:00';
                    }
                } else {
                    timePicker.removeAttribute('required');
                    timePicker.value = '';
                }
            }
        })

        new IMask(timePicker, {
            mask: 'HH:MM',
            lazy: true,
            blocks: {
                HH: {
                    mask: IMask.MaskedRange,
                    from: 8,
                    to: 18
                },

                MM: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59
                },
            },
            autofix: true,
            format: function (date) {
                alert(date.HH + ':' + date.MM);
            }
        });
    }
}
